module.exports = __webpack_public_path__ + "static/media/background-banner_black.62acd1cb.jpg";